<div class="camera-wrapper">
  <label *ngIf="!showImage" for="cameraSelect">Selecciona cámara:</label>
  <select *ngIf="!showImage" id="cameraSelect" (change)="onDeviceChange($event)">
    <option *ngFor="let device of devices" [value]="device.deviceId">
      {{ device.label || 'Cámara ' + device.deviceId }}
    </option>
  </select>

  <video *ngIf="!showImage" #videoElement autoplay muted></video>

  <button *ngIf="!showImage" class="btn btn-primary" (click)="captureImage()">Capturar imagen</button>

  <canvas #canvasElement style="display: none;"></canvas>

  <div *ngIf="showImage">
    <h4>Imagen capturada:</h4>
    <img [src]="capturedImage" alt="captura" />
    <div class="d-flex flex-row align-items-center justify-content-end w-100 mt-2">
      <button class="btn btn-warning w-100" (click)="reintentar()">Tomar otra vez.</button>
    </div>
  </div>
</div>
